import { graphql } from 'react-relay';

import useMutation from './useMutation';

const mutation = graphql`
  mutation useCreateIrelandTaxiTelematicsLeadMutation(
    $input: CreateIrelandTaxiTelematicsLeadInput!
  ) {
    createIrelandTaxiTelematicsLead(input: $input) {
      __typename
      ... on CreateIrelandTaxiTelematicsLeadSuccess {
        viewer {
          ...SessionLayout_viewer
        }
        user {
          customerNumber
          givenNames
        }
      }
      ... on CreateIrelandTaxiTelematicsLeadError {
        errorMessage
      }
    }
  }
`;

export default function useCreateIrelandTaxiTelematicsLeadMutation({
  onComplete,
  onError,
}) {
  return useMutation(mutation, { onComplete, onError });
}
